import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LIST_DEFAULT_PAGE } from "../../constants/list";
import { ListType } from "../../type/list.type";


const initialState: ListType = {
    currentPage : LIST_DEFAULT_PAGE,
    fromDetail: false,
};

const listSlice = createSlice({
    name: "list",
    initialState,
    reducers: {
        setCurrentListPage: (state, action: PayloadAction<ListType>) => {
            state.currentPage = action.payload.currentPage;
        },
        setComingFromDetail: (state, action: PayloadAction<ListType>) => {
            state.fromDetail = action.payload.fromDetail;
        },
    },
});

export const { setCurrentListPage, setComingFromDetail } = listSlice.actions;

export default listSlice.reducer;
